import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable()
export class LogService {

  constructor() {
  }

  log(message: string, ...optionalParams: any[]) {
    if (this.logActif()) {
      console.log(this.format(message, optionalParams));
    }
  }

  format(message: string, ...optionalParams: any[]): string {
    for (const optional in optionalParams[0]) {
      message = message.replace('{' + optional + '}', optionalParams[0][optional]);
    }
    return message;
  }

  info(message?: any, ...optionalParams: any[]) {
    if (this.logActif()) {
      console.info(this.format(message, optionalParams));
    }
  }

  error(message?: any, ...optionalParams: any[]) {
    if (this.logActif()) {
      console.error(this.format(message, optionalParams));
    }
  }

  private logActif() {
    return environment.activate_log === 'true';
  }
}
